exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".friendList[data-v-2d39fad4]{font-size:12px;line-height:20px;border:1px solid #d9d9d9;background-color:#fafafa;text-align:center;padding:20px}.friendList a[data-v-2d39fad4]{display:inline-block;padding:0 20px;position:relative}.friendList a[data-v-2d39fad4]:after{content:\"\";position:absolute;top:4px;width:1px;height:14px;right:0;background-color:#f2f2f2;display:block}", ""]);

// exports
